import { Directive, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[scWritingMode]',
  exportAs: 'scWritingMode',
  providers: [NgModel],
  host: {
    '(input)': 'onInputChange($event.target, $event.target.value)'
  }
})
export class WritingModeDirective {

  /** the writing mode */
  @Input('mode') mode: WritingMode = WritingMode.Normal;
  /** string considered to set first letter after to upper case
     *  default it's space */
  @Input('splitter') splitter: string = ' ';

  private _preStart: number = 0;
  private _preEnd: number = 0;
  constructor() { }

  /**
   * Get Caret
   * @param el
   */
  private getCaret(el: any) {
    return {
      start: el.selectionStart,
      end: el.selectionEnd,
    };
  }

  /**
   * set Caret
   * @param el
   * @param start
   * @param end
   */
  private setCaret(el: any, start: any, end: any) {
    el.selectionStart = start;
    el.selectionEnd = end;
    el.focus();
  }
  /**
   * input event handler
   * @param el
   * @param value
   */

  onInputChange(el: any, value: string) {
    
    let { start, end } = this.getCaret(el);
    this._preStart= start;
    this._preEnd = end;
    if(this._preStart !== start && this._preEnd !== end && this._preEnd != undefined && this._preStart != undefined){
      if (value[0] === ' ' && start === 1 && end === 1) {
        start = 0;
        end = 0;
      }
      this.convertValue(el, value);
    }
    this.setCaret(el, start, end);
  }

  /**
   * convert value following the writing mode
   * Since extra input and blur events are dispatched, if you bind a callback to input event or blur event,
   * the callback will be invoked twice on input or blur.
   * To overcome the disadvantage, a debounced function is recommended for the event binding.
   * @param el
   * @param value
   */
  private convertValue(el: any, value: any) {
    el.value = this.changeTextCase(value);
    this.dispatchEvent(el, 'input');
  }

  /**
   * Dispatch input or blur event
   * @param el
   * @param eventType
   */
  private dispatchEvent(el: any, eventType: any) {
    const event = new Event(eventType, { "bubbles": false, "cancelable": false });
    el.dispatchEvent(event);
  }


  /**
  * will change the value according to the passed writing mode
  * @param value
  */
  private changeTextCase(value: string): string {
    if (value && this.mode) {
      if (this.mode === WritingMode.UpperCase) {
        value = value.toUpperCase();
      }

      if (this.mode === WritingMode.LowerCase) {
        value = value.toLowerCase();
      }

      if (this.mode === WritingMode.FirstLetterCaps) {
        let splitter = this.splitter ? this.splitter : ' ';
        // set first letter to Caps after all available splitter
        value = this.capitalizeFirstLetter(value, splitter);
      }
    }
    return value;
  }

  /**
   * will capitzalize the first letter of the sentence. and after each splitter 
   * @param str
   * @param splitter
   */
  private capitalizeFirstLetter(str: string, splitter: string): string {
    let splitStr = str.toLowerCase().split(splitter);
    for (var j = 0; j < splitStr.length; j++) {
      splitStr[j] = splitStr[j].charAt(0).toUpperCase() + splitStr[j].substring(1);
    }
    // return the joined string
    return splitStr.join(splitter);
  }

  ///**
  // * will return the passed string in camel case
  // * @param str
  // */
  //private toCamelCase(str: string): string {
  //  return str
  //    .replace(/\s(.)/g, function (v) { return v.toUpperCase(); })
  //    .replace(/\s/g, '')
  //    .replace(/^(.)/, function (v) { return v.toLowerCase(); });
  //}

  //private toPascalCase(str: string): string {
  //  return str.replace(/(\w)(\w*)/g, function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
  //}


}

export enum WritingMode {
  Normal = 'normal',
  LowerCase = 'lower-case',
  UpperCase = 'upper-case',
  FirstLetterCaps = 'first-letter-caps'
}
